import { crossFarmUuid } from '@xarvio/frontend-core-platform/lib/constants';
import { getPageUrlDic, Page } from './routes';

// Which Pages belong to the cross-farm dashboard section. Rename a route URL in routes.ts only.
const CROSS_FARM_DASHBOARD_PAGES = [
  Page.CROSS_FARM_DASHBOARD,
  Page.CROSS_FARM_DASHBOARD_GENERAL,
  Page.CROSS_FARM_DASHBOARD_RISKS,
  Page.CROSS_FARM_DASHBOARD_TASKS,
  Page.CROSS_FARM_DASHBOARD_SOIL,
  Page.CROSS_FARM_DASHBOARD_CROP_DETAILS,
  Page.CROSS_FARM_DASHBOARD_FIELD_TRIALS,
  Page.CROSS_FARM_DASHBOARD_SCOUTING,
  Page.CROSS_FARM_DASHBOARD_PROTOCOLS,
  Page.CROSS_FARM_DASHBOARD_TRIPS,
  Page.CROSS_FARM_DASHBOARD_HEALTHY_FIELDS_OVERVIEW,
  Page.CROSS_FARM_DASHBOARD_HEALTHY_FIELDS__COMMERCIAL_PARTNER,
  Page.CROSS_FARM_DASHBOARD_HEALTHY_FIELDS__SEASON_COORDINATOR,
  Page.CROSS_FARM_DASHBOARD_HEALTHY_FIELDS__AGRONOMIST,
  Page.CROSS_FARM_DASHBOARD_HEALTHY_FIELDS__CONTRACTOR,
  Page.CROSS_FARM_DASHBOARD_FIELD_NOTES,
  Page.CROSS_FARM_DASHBOARD_SMART_SPRAYER,
] as const;

const pageUrlDic = getPageUrlDic({ prefix: '', farmUuid: crossFarmUuid });

const CROSS_FARM_DASHBOARD_PATHS = CROSS_FARM_DASHBOARD_PAGES.map(
  (page) => pageUrlDic[page],
);

export const isCrossFarmDashboardPathname = (pathname: string) =>
  CROSS_FARM_DASHBOARD_PATHS.some((path) => pathname.endsWith(path));

export const isCrossFarmDashboardHomePathname = (pathname: string) =>
  pathname.endsWith(pageUrlDic[Page.CROSS_FARM_DASHBOARD]);
